import Phaser from 'phaser';

/**
 * Арочный портал-зеркало — заменяет скамейку. Герой материализуется из него
 * при спавне/респауне. Постамент стоит на полу, базовая точка respawn — над
 * постаментом, чтобы герой выходил «из портала» на твёрдую землю.
 */
export class Portal extends Phaser.GameObjects.Sprite {
  private glowTween?: Phaser.Tweens.Tween;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'portal');
    scene.add.existing(this);
    this.setOrigin(0.5, 1); // anchor — основание (низ постамента) на полу
    // Лёгкое «дыхание» свечения портала
    this.glowTween = scene.tweens.add({
      targets: this,
      alpha: 0.85,
      duration: 1400,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.inOut',
    });
  }

  /** Точка респауна — на полу прямо под порталом, чтобы герой стоял на земле. */
  getRespawnPoint(): { x: number; y: number } {
    // origin (0.5, 1) — this.y это низ постамента (= уровень пола).
    // Герой 104 высотой, центр должен быть на 52 выше пола.
    return { x: this.x, y: this.y - 52 };
  }

  /** Зона интеракции — горизонтальное расстояние от центра портала. */
  getInteractRadius(): number {
    return 50;
  }

  /** Уровень пола, на котором стоит портал. */
  getFloorY(): number {
    return this.y;
  }

  /** Кратковременная вспышка — портал ярче во время появления героя. */
  flashEmerge() {
    if (this.glowTween) {
      this.glowTween.stop();
    }
    this.setAlpha(1);
    this.scene.tweens.add({
      targets: this,
      scale: 1.08,
      duration: 220,
      yoyo: true,
      ease: 'Quad.out',
      onComplete: () => {
        this.setScale(1);
        this.glowTween = this.scene.tweens.add({
          targets: this,
          alpha: 0.85,
          duration: 1400,
          yoyo: true,
          repeat: -1,
          ease: 'Sine.inOut',
        });
      },
    });
  }
}
